import { Collapsible } from '../interfaces';
import { Tba } from './tba';
import { TbaRangeType } from './tba-range-type';
import { Container } from './container';

export class TbaRangeResult implements Collapsible {
  tbaRangeResultId: number;
  tba: Tba;
  tbaRangeType: TbaRangeType;
  discussion: string;
  lowerQuartile: number;
  upperQuartile: number;
  minimum: number;
  median: number;
  maximum: number;
  testedValue: number;
  inRange?: boolean;
  container: Container;
  collapsed: boolean;
}
